import styled from "@emotion/styled";

import { formatShortDateWithWeekday } from "@/config/date-fns";
import { DailyDiaryFragment, DailyShortDiaryFragment } from "@/generated/graphql/graphql";

const Time = styled.time`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 6.25em;
  white-space: nowrap;
  flex-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

type DailyDiaryDateTitleProps = { dailyDiary: Pick<DailyDiaryFragment | DailyShortDiaryFragment, "date"> };

export function DailyDiaryDateTitle({ dailyDiary }: DailyDiaryDateTitleProps) {
  return <Time dateTime={dailyDiary.date}>{formatShortDateWithWeekday(dailyDiary.date)}</Time>;
}
